import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { CommonPaths } from '@utils/path'

import { WalletWithdrawTransactionFailedPage } from './WalletWithdrawTransactionFailedPage'

export const TradersRoomWalletWithdrawTransactionFailedPage: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const handleCancel = () => {
    navigate(CommonPaths.TradersRoomWallets)
  }

  return (
    <WalletWithdrawTransactionFailedPage
      title={t('Transactions.Funds not withdrawn')}
      onCancel={handleCancel}
    />
  )
}
